import React, {useState} from "react";
import Icon from "../baseComponents/gui/icon/Icon";
import styles from "./SocialBlock.module.scss";


const SocialBlockItem = React.forwardRef(
  function SocialBlockItem({href, icon}, ref) {
    const [isShowPath, setShowPath] = useState(true);
    const url = new URL(href);
    const domain = url.hostname;
    return (
      <a href={href}
         target={"_blank"}
         area-label={`перейти на ${domain}`}
         title={`перейти на ${domain}`}
         className={styles.socialBlock__item}
         onMouseEnter={() => setShowPath(false)}
         onMouseLeave={() => setShowPath(true)}
         style={{
           [`--path-opacity`]: isShowPath ? 1 : 0,
         }}
         ref={ref}
      >
        <Icon name={icon} width={40} height={40}/>
      </a>
    );
  });
export default SocialBlockItem;
SocialBlockItem.propTypes = {};

